/* unplugin-vue-components disabled */import script from "./callQueue.vue?vue&type=script&lang=ts&setup=true"
export * from "./callQueue.vue?vue&type=script&lang=ts&setup=true"

import "./callQueue.vue?vue&type=style&index=0&id=bba54408&lang=stylus"
import "./callQueue.vue?vue&type=style&index=1&id=bba54408&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba54408"]])

export default __exports__